import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import Modal from "@insite/mobius/Modal";
import customLoadInventory from "@NA/Handlers/GetInventory";
import ADIProductSaleInfo from "@NA/Components/ProductList/ADIProductSaleInfo";
import { ProductCardSelections } from "@NA/Widgets/AIProton/AIProtonModel";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import Link from "@insite/mobius/Link/Link";
import { Hidden } from "@insite/mobius/index";
import DeliveryIcon from "@NA/Icons/DeliveryIcon";
import ADILocationFinder from "@NA/Components/ADILocationFinder";
import AIDescription from "@NA/Widgets/AIProton/AIDescription";
import AIProductImage from "@NA/Widgets/AIProton/AIProductImage";
import AIProductBrand from "@NA/Widgets/AIProton/AIProductBrand";
import GridItem from "@insite/mobius/GridItem";
import GridContainer from "@insite/mobius/GridContainer";
import { ProductCarouselProductStyles, productCardStyles } from "@NA/Widgets/AIProton/AIProtonStyles";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import ProductPrice from "@NA/Overrides/Components/ProductPrice";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import ADILBShippedByVendor from "@NA/Components/ADILBShippedByVendor";
import ADILBStorePickup from "@NA/Components/ADILBStorePickup";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ProductComapreCheckbox, {
    ProductComapreCheckboxStyles,
} from "@NA/Widgets/ProductCompare/ProductCompareCheckbox";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import ADIProductAddToCartButton from "@NA/Components/ProductDetail/ADIProductAddToCartButton";
import { getMaxProductHeight } from "@NA/Utils/Utility";

interface OwnProps {
    extendedStyles?: ProductCarouselProductStyles;
    product: any;
    carouselId: string;
    title: string;
    updateProductInfo: any;
    productInfo: any;
    showItemCompare: boolean;
    sourceName: string;
}

const mapStateToProps = (state: CustomApplicationState, ownProps: OwnProps) => {
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    const currentPage = getCurrentPage(state).type;
    const isPdp = currentPage === "ProductDetailsPage";
    return {
        settingsCollection: getSettingsCollection(state),
        cartState: getCurrentCartState(state).value,
        cartStateLoading: getCurrentCartState(state).isLoading,
        isAuthenticated: state.context.session.isAuthenticated,
        productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
        showADIAddToCart: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
        session: getSession(state),
        isPdp,
        pageType: getCurrentPage(state).type,
        productSettings: getSettingsCollection(state).productSettings,
    };
};
const mapDispatchToProps = {
    updateProductInfo,
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & ProductCardSelections;
const styles = productCardStyles;

const AICarouselProduct: React.FC<Props> = ({
    product,
    cartState,
    isAuthenticated,
    showBrand,
    showTitle,
    showPartNumbers,
    showAvailability,
    showAttributes,
    showImage,
    showCompare,
    showPrice,
    updateProductInfo,
    productInfo,
    showSavingsAmount,
    showSavingsPercent,
    carouselId,
    showADIAddToCart,
    session,
    title,
    isPdp,
    pageType,
    showItemCompare,
    sourceName,
}) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const dispatch: any = useDispatch();
    const [inventoryResult, setInventoryResult] = useState<any>(null);
    const carLineItem = cartState?.cartLines?.find(cartLine => cartLine.modelNumber === product.modelNumber);
    const isItemCompare = showItemCompare !== undefined ? showItemCompare : true;

    const viewAvailabilityByWarehouseClickHandler = () => {
        setModalIsOpen(true);
        dispatch(
            customLoadInventory({
                productId: product.erpNumber,
                onSuccess(result: any) {
                    setInventoryResult(result);
                },
            }),
        );
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const updateQuantity = (qtyOrdered: number) => {
        updateProductInfo({ id: carouselId, productId: product.id, qtyOrdered });
    };

    const updateUnitOfMeasure = (unitOfMeasure: string) => {
        updateProductInfo({ id: carouselId, productId: product.id, unitOfMeasure });
    };
    const [minBrandHeight, setMinBrandHeight] = useState(15);
    const [minDescHeight, setMinDescHeight] = useState(15);
    const [minPartHeight, setMinPartHeight] = useState(14);
    const [minPriceHeight, setMinPriceHeight] = useState(40);
    const [minStoreHeight, setMinStoreHeight] = useState(10);
    const [minDeliveryHeight, setMinDeliveryHeight] = useState(15);
    const [minStockHeight, setMinStockHeight] = useState(15);

    useEffect(() => {
        const maxBrandHeight = getMaxProductHeight('[data-test-selector="brandLink"]');
        const maxDescHeight = getMaxProductHeight('[data-test-selector="productDescriptionLink"]');
        const maxPartHeight = getMaxProductHeight(".partNumber");
        const maxPriceHeight = getMaxProductHeight('[data-test-selector="productPrice_unitNetPrice"]');
        const maxStoreHeight = getMaxProductHeight(".storeItem");
        const maxDeliveryHeight = getMaxProductHeight(".deliveryItem");
        const maxStockHeight = getMaxProductHeight(".stockItem");

        setMinBrandHeight(maxBrandHeight);
        setMinDescHeight(maxDescHeight);
        setMinPartHeight(maxPartHeight);
        setMinPriceHeight(maxPriceHeight);
        setMinStoreHeight(maxStoreHeight);
        setMinDeliveryHeight(maxDeliveryHeight);
        setMinStockHeight(maxStockHeight);
    }, []);

    if (!product) {
        return null;
    }
    const productContext = {
        product,
        productInfo,
        onUnitOfMeasureChanged: updateUnitOfMeasure,
        onQtyOrderedChanged: updateQuantity,
    };





    const freeShippingAmount = Number(session.properties.freeshipThresholdAmt);
    const pricing = productInfo?.pricing || product?.pricing;
    const isLbProduct = product?.properties?.logicBroker?.toLowerCase() === "yes";
    return (
        <>
            <ProductContext.Provider value={productContext} {...styles.mainContainer}>
                <GridContainer {...(styles.pdpWrapper)} key={product.id}>
                    <StyledWrapper {...styles.tagsWrapper}>
                        <ADIProductSaleInfo product={product} isAuthenticated={isAuthenticated} pricing={pricing} />
                    </StyledWrapper>
                    {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                    {isItemCompare && pageType === "ProductDetailsPage" ? (
                        <StyledWrapper {...styles.productCompareCheckbox}>
                            <ProductComapreCheckbox extendedStyles={styles.productComapreCheckboxStyles} />
                        </StyledWrapper>
                    ) : (
                        ""
                    )}
                    {/* ----- LHS ----- */}
                    <GridItem {...styles.productLeftGrid}>
                        <GridContainer>
                            {showImage && (
                                <GridItem {...styles.imageGridItem}>
                                    <AIProductImage
                                        product={product}
                                        extendedStyles={styles.productImageStyles}
                                        title={title}
                                    />
                                </GridItem>
                            )}
                            {showPartNumbers && (
                                <Hidden above="xs" {...styles.productPartsDetailsWrapper}>
                                    <GridItem {...styles.productPartsDetails}>
                                        {/* ADINA-60143 For Buy again widget */}
                                        {/* <Typography as="p">{product.manufacturerItem}</Typography>
                                        <Typography as="p">{product.modelNumber}</Typography> */}
                                        <Typography as="p">{product.modelNumber}</Typography>
                                        <Typography as="p">{product.erpNumber}</Typography>
                                    </GridItem>
                                </Hidden>
                            )}
                        </GridContainer>
                    </GridItem>
                    {/* ----- RHS ----- */}
                    <GridItem {...styles.productRightGrid}>
                        <GridContainer>
                            {product.brand && showBrand && (
                                <GridItem {...styles.productBrandGridItem} style={{ minHeight: `${minBrandHeight}px` }}>
                                    <AIProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                                </GridItem>
                            )}
                            {showTitle && (
                                <GridItem {...(styles.pdpDescriptionGridItem)} style={{ minHeight: `${minDescHeight}px` }}>
                                    <AIDescription
                                        product={product}
                                        extendedStyles={styles.productDescriptionStyles}
                                        session={session}
                                        title={title}
                                    />
                                </GridItem>
                            )}
                            {showPartNumbers && (
                                <Hidden below="sm" {...styles.productPartsDetailsWrapper}>
                                    <GridItem
                                        {...styles.productPartsDetails}
                                        className="partNumber"
                                        style={{ minHeight: `${minPartHeight}px` }}
                                    >
                                        {/* ADINA-60143 For Buy again widget */}
                                        {/* <Typography as="span">{product.manufacturerItem}</Typography> */}
                                        <Typography as="span">{product.modelNumber}</Typography>
                                        <Typography as="span">|</Typography>
                                        {/* <Typography as="span">{product.modelNumber}</Typography> */}
                                        <Typography as="span">{product.erpNumber}</Typography>
                                    </GridItem>
                                </Hidden>
                            )}
                            {showPrice && (
                                <GridItem
                                    {...styles.ADIproductPrice}
                                    className="priceItem"
                                    style={{ minHeight: `${minPriceHeight}px` }}
                                >
                                    <StyledWrapper {...styles.ADIproductPriceWrapper}>
                                        <VisuallyHidden
                                            as="label"
                                            htmlFor={`${carouselId}-uom`}
                                            id={`${carouselId}-uom-label`}
                                        >
                                            {translate("U/M")}
                                        </VisuallyHidden>

                                        <ProductPrice
                                            showLabel={false}
                                            showSavings={true}
                                            showSavingsAmount={showSavingsAmount}
                                            showSavingsPercent={showSavingsPercent}
                                            product={product}
                                            extendedStyles={styles.ProductPrice}
                                        />
                                    </StyledWrapper>
                                </GridItem>
                            )}
                            <GridItem {...styles.productStore}>
                                <ADILBStorePickup isLbProduct={isLbProduct} />
                            </GridItem>
                            {freeShippingAmount && freeShippingAmount > 0 ? (
                                <GridItem
                                    {...styles.productDelivery}
                                    className="deliveryItem"
                                    style={{ minHeight: `${minDeliveryHeight}px` }}
                                >
                                    <DeliveryIcon />
                                    <StyledWrapper>
                                        <Typography>{translate("Delivery")}</Typography>
                                        {((Number(product.pricing.unitListPrice) !== 0 && product.pricing.unitListPrice != null) ?
                                            <Typography
                                                {...(product.pricing.unitListPrice >= freeShippingAmount
                                                    ? styles.free
                                                    : styles.notFree)}
                                            >
                                                {product.pricing.unitListPrice >= freeShippingAmount
                                                    ? translate("Free")
                                                    : translate(`Free for orders $${freeShippingAmount} & above`)}
                                            </Typography>
                                            :
                                            <Typography></Typography>
                                        )}
                                    </StyledWrapper>
                                </GridItem>
                            ) : null}

                            {showAvailability && (
                                product.properties["logicBroker"] && product.properties["logicBroker"]?.toLowerCase() === "yes" ?
                                    (
                                        <GridItem
                                            {...(styles.pdpStockAvailability)}
                                            className="stockItem"
                                            style={{ minHeight: `${minStockHeight}px` }}
                                        >
                                            <ADILBShippedByVendor vendorName={product.brand?.name ?? ""} view="Grid" />
                                        </GridItem>
                                    )
                                    :
                                    (
                                        <GridItem
                                            {...(styles.pdpStockAvailability)}
                                            className="stockItem"
                                            style={{ minHeight: `${minStockHeight}px` }}
                                        >
                                            {product ?
                                                (!product.properties["inventoryMessage"] || product.properties["inventoryMessage"] !== "Special Order" ? (
                                                    <Typography {...styles.availibilityGrid}>
                                                        <Typography {...styles.availibility}>
                                                            <Link onClick={viewAvailabilityByWarehouseClickHandler}>
                                                                {translate("Stock Availability")}
                                                            </Link>
                                                        </Typography>
                                                        <Modal
                                                            {...styles.availabilityByWarehouseModal}
                                                            headline={translate("Stock Availability")}
                                                            isOpen={undefined}
                                                            handleClose={undefined}
                                                        >
                                                            <ADILocationFinder
                                                                productId={product.productNumber}
                                                                warehouseDetails={undefined}
                                                            />
                                                        </Modal>
                                                    </Typography>
                                                ) : (
                                                    <Typography {...styles.availibilityGrid}>
                                                        <Typography {...styles.stockMsg}>{translate("Special Order")}</Typography>
                                                    </Typography>
                                                )
                                                ) : null}

                                            <Modal
                                                {...styles.availabilityByWarehouseModal}
                                                headline={translate("Stock Availability")}
                                                isOpen={modalIsOpen}
                                                handleClose={modalCloseHandler}
                                            >
                                                <ADILocationFinder
                                                    productId={product.productNumber}
                                                    warehouseDetails={inventoryResult}
                                                />
                                            </Modal>
                                        </GridItem>)
                            )}
                        </GridContainer>
                    </GridItem>
                    {session.isAuthenticated && showADIAddToCart && (
                        <StyledWrapper {...styles.addToCartContainer}>
                            <StyledWrapper {...styles.addToCartButtonGridItem}>
                                <ADIProductAddToCartButton
                                    sourceName="Buy Again"
                                    productLine={product}
                                    buttonLabel="Add To Cart"
                                />
                            </StyledWrapper>
                        </StyledWrapper>
                    )}
                </GridContainer>
            </ProductContext.Provider>
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AICarouselProduct);

